import { render } from "./Faq.vue?vue&type=template&id=0f27128c&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=0f27128c&scoped=true&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f27128c"]])

export default __exports__